import React from 'react';
import classes from "./App.module.css";
import { Redirect, Link, Route, Switch } from 'react-router-dom';
import { Layout, Menu, Icon, Col, Row, Dropdown, ConfigProvider, Button, message } from 'antd';
import { asyncComponent } from '../utils/asyncComponent';
import { connect } from 'react-redux';
import zhCN from 'antd/es/locale/zh_CN';
import djlogo from './djlogo.png';
import { app_SET, GETROLEAUTH } from '../redux/actions/appAction';
import { OfflineModal } from '../components';
import moment from 'moment';
import 'moment/locale/zh-cn';


import { Tabs } from 'antd';

const { TabPane } = Tabs;


moment().utcOffset('+08:00');
const { Content, Footer, Sider, } = Layout;
const SubMenu = Menu.SubMenu;

const componentList = {
    AsyncUserList: asyncComponent(() => import("./user")),
    AsyncSetPwd: asyncComponent(() => import("./setting/ChangePwd")),
    AsyncSetAlert: asyncComponent(() => import("./setting/SetAlert")),
    AsyncParameter: asyncComponent(() => import("./setting/parameter")),
    AsyncTestColor: asyncComponent(() => import("./test/TestColor")),
    AsyncTestApi: asyncComponent(() => import("./test/TestApi")),
    AsyncAntdCompTest: asyncComponent(() => import("./test/antdCompTest")),
    AsyncHome: asyncComponent(() => import("./Home")),
    AsyncDerClientList: asyncComponent(() => import("./client/derClientList")),
    AsyncClientList: asyncComponent(() => import("./client/clientList")),
    AsyncClientPending: asyncComponent(() => import("./client/clientPending")),
    AsyncClientCredit: asyncComponent(() => import("./client/clientCredit")),
    AsyncOrderList: asyncComponent(() => import("./order/orderList")),
    AsyncDerOrderList: asyncComponent(() => import("./derOrder/orderList")),
    AsyncDerOrderPending: asyncComponent(() => import("./derOrder/orderPending")),
    AsyncOrderPending: asyncComponent(() => import("./order/orderPending")),
    AsyncReportForClientQuota: asyncComponent(() => import("./order/reportForClientQuota")),
    AsyncReportForDerClientQuota: asyncComponent(() => import("./derOrder/reportForClientQuota")),
    AsyncRepayFail: asyncComponent(() => import("./order/repayFail")),
    AsyncOrderExceedThirty: asyncComponent(() => import("./order/orderExceedThirty")),
    AsyncOrderExceedSixty: asyncComponent(() => import("./order/orderExceedSixty")),
    AsyncNoUsed30: asyncComponent(() => import("./order/noUsed30")),
    AsyncProjectAmount: asyncComponent(() => import("./purRecordOrder/projectAmount")),
    AsyncPurOrderPending: asyncComponent(() => import("./purOrder/purOrderPending")),
    AsyncPurRecordOrderPending: asyncComponent(() => import("./purRecordOrder/purRecordOrderPending")),
    AsyncPurOrderList: asyncComponent(() => import("./purOrder/purOrderList")),
    AsyncPurRecordOrderList: asyncComponent(() => import("./purRecordOrder/purRecordOrderList")),
    AsyncIceEnter: asyncComponent(() => import("./ice/enter")),
    AsyncRoleAuth: asyncComponent(() => import("./setting/roleAuth")),
    AsyncNotFound: asyncComponent(() => import("./NotFound")),
    AsyncMonitorException: asyncComponent(() => import("./monitor/exception")),
    AsyncMonitorEngException: asyncComponent(() => import("./monitor/engException")),
    AsyncMonitorHistoryOrderException: asyncComponent(() => import("./monitor/historyOrder")),
    AsyncClientRecommend: asyncComponent(() => import("./client/clientRecomend")),
    AsyncClientRecommendSelf: asyncComponent(() => import("./client/clientRecomendSelf")),
    AsyncDerClientRecommend: asyncComponent(() => import("./client/derClientRecomend")),
    AsyncFullEnter: asyncComponent(() => import("./fullScreen/enter")),
    AsyncPurLoanAfter: asyncComponent(() => import("./purOrder/purLoanAfter")),
    AsyncDerLoanAfter: asyncComponent(() => import("./derOrderAfter/derWareHouseConfirm")),
    AsyncDerLoanAfterIn: asyncComponent(() => import("./derOrderAfter/derWareHouseIn")),
    AsyncReportForBrief: asyncComponent(() => import("./order/reportForBrief")),
    AsyncClientLegalPerson: asyncComponent(() => import("./client/clientLegalPerson")),
    AsyncControlProductOrder: asyncComponent(() => import("./order/controlProductOrder")),
    AsyncDerOrderWareHouseOut: asyncComponent(() => import("./derOrder/warehouseOut")),
};

const urlList = [
    { url: '/client/clientLegalPerson', compt: 'AsyncClientLegalPerson' },
    { url: '/client/recommend', compt: 'AsyncClientRecommend' },
    { url: '/client/recommend-self', compt: 'AsyncClientRecommendSelf' },
    { url: '/derClient/recommend', compt: 'AsyncDerClientRecommend' },
    { url: '/derLoanAfter/out', compt: 'AsyncDerLoanAfter' },
    { url: '/derLoanAfter/in', compt: 'AsyncDerLoanAfterIn' },

    { url: '/client/list', compt: 'AsyncClientList' },
    { url: '/derClient/list', compt: 'AsyncDerClientList' },
    { url: '/monitor/exception', compt: 'AsyncMonitorException' },
    { url: '/monitor/engException', compt: 'AsyncMonitorEngException' },
    { url: '/monitor/historyOrder', compt: 'AsyncMonitorHistoryOrderException' },
    { url: '/client/pending', compt: 'AsyncClientPending' },
    { url: '/order/list', compt: 'AsyncOrderList' },
    { url: '/derOrder/list', compt: 'AsyncDerOrderList' },
    { url: '/derOrder/warehouseOut', compt: 'AsyncDerOrderWareHouseOut' },
    { url: '/order/controlProduct', compt: 'AsyncControlProductOrder' },
    { url: '/client/credit', compt: 'AsyncClientCredit' },
    { url: '/order/reportForClientQuota', compt: 'AsyncReportForClientQuota' },
    { url: '/derOrder/reportForClientQuota', compt: 'AsyncReportForDerClientQuota' },
    { url: '/order/pending', compt: 'AsyncOrderPending' },
    { url: '/derOrder/pending', compt: 'AsyncDerOrderPending' },
    { url: '/order/repayFail', compt: 'AsyncRepayFail' },
    { url: '/order/exceedThirty', compt: 'AsyncOrderExceedThirty' },
    { url: '/order/exceedSixty', compt: 'AsyncOrderExceedSixty' },
    { url: '/order/noUsed30', compt: 'AsyncNoUsed30' },
    { url: '/purRecordOrder/projectAmount', compt: 'AsyncProjectAmount' },
    { url: '/purOrder/list', compt: 'AsyncPurOrderList' },
    { url: '/purOrder/purLoanAfter', compt: 'AsyncPurLoanAfter' },
    { url: '/purRecordOrder/list', compt: 'AsyncPurRecordOrderList' },
    { url: '/purOrder/pending', compt: 'AsyncPurOrderPending' },
    { url: '/purRecordOrder/pending', compt: 'AsyncPurRecordOrderPending' },
    { url: '/user/list', compt: 'AsyncUserList' },
    { url: '/setting/password', compt: 'AsyncSetPwd' },
    { url: '/setting/alert', compt: 'AsyncSetAlert' },
    { url: '/setting/parameter', compt: 'AsyncParameter' },
    { url: '/setting/roleAuth', compt: 'AsyncRoleAuth' },
    { url: '/test/color', compt: 'AsyncTestColor' },
    { url: '/test/api', compt: 'AsyncTestApi' },
    { url: '/test/antdcomp', compt: 'AsyncAntdCompTest' },
    { url: '/ice/enter', compt: 'AsyncIceEnter' },
    { url: '/fullScreen/enter', compt: 'AsyncFullEnter' },
    { url: '/order/reportForBrief', compt: 'AsyncReportForBrief' },
];

var listRun = []  //switch Router用到，默认为空

// 获取当前路由信息
function getCurrentRouteInfo() {
    let routeInfo = undefined;
    const routePath = window.location.pathname;
    listRun.some(item => {
        if (item.url === routePath) {
            routeInfo = item;
            return true;
        }
    });
    return routeInfo;
}

// 根据url获取组件
function getComponent(route) {
    let component = undefined;
    urlList.some(item => {
        if (item.url === route) {
            component = componentList[item.compt];
            return true;
        }
    });
    return component;
}

// 检测openedRoutes中是否存在路由,如果存在，返回一个对象，包含路由所在数组中索引
function getRouteIndex(url, routes) {
    let index = undefined;
    routes.some((item, i) => {
        if (item.url === url) {
            index = i;
            return true;
        }
    });
    // 因为index可能为0导致false，这里检测不为undefined
    if (index !== undefined) {
        return index;
    } else {
        return -1;
    }
}

// 初始化状态
let inited = false;
class AppRender extends React.Component {
    constructor(props) {
        super(props);
        this.state = { menuCollapsed: false, openKeys: [] };
    }
    componentDidMount() {
        const { app, app_set, getroleauth } = this.props;
        app_set({ screenType: window.innerWidth < 780 ? 'mb' : 'pc' })   //传一个默认值进去
        let roleid = sessionStorage.getItem('roleid');
        let user_name = sessionStorage.getItem('user_name');

        const fnGetRoleAuth = async () => {
            //去获取roleAuth权限
            let msg = await getroleauth({ roleid: roleid });
            if (msg === '获取成功') {
                //成功获取 已在action中保存
            } else if (msg === '无权限') {
                //获取失败，可能是没有配置
                this.props.history.push('/login');
                return (
                    message.error('无权限，请联系管理员', 10)
                )
            } else {
                //出错了
                console.log(msg);
            }
        }
        roleid && fnGetRoleAuth();
    }

    menutop = (
        <Menu >
            <Menu.Item onClick={() => {
                // 退出登录，清空路由
                this.props.app_set({
                    openedRoutes: []
                });
            }}>
                <Link to='/login' ><Icon type='logout' /> 退出登陆</Link>
            </Menu.Item>
            <Menu.Item onClick={() => {
                let passwordUrlInfo;
                listRun.some(item => item.url === "/setting/password" ? (passwordUrlInfo = item, true) : false);
                // 没有权限就提示以下
                if (!passwordUrlInfo) {
                    message.error("没有权限");
                    return;
                }
                const { app, app_set } = this.props;
                const { openedRoutes } = app;

                let newOpenedRoutes = [...app.openedRoutes];
                // 存在直接跳转
                let index = getRouteIndex("/setting/password", openedRoutes);

                if (index !== -1) {
                    // 存在页面，跳转
                    app_set({ activeTab: index });
                    return;
                } else {
                    // 不存在则添加页面
                    newOpenedRoutes.push(passwordUrlInfo);
                    // 设置状态添加路由页面，且跳转到该页
                    app_set({ openedRoutes: newOpenedRoutes, activeTab: newOpenedRoutes.length - 1 });
                }
            }}>
                <Link to='/setting/password' ><Icon type='setting' /> 修改密码</Link>
            </Menu.Item>
        </Menu>
    );




    render() {
        const { app, app_set, getroleauth } = this.props;
        const { offline, APPloading, navBarHidden, screenType, loginUserRoleAuth, menuStandard, refreshTime } = app;

        const { openedRoutes, activeTab } = app;

        //测试是否脱机
        window.addEventListener('online', function () {
            console.log('online')
            app_set({ offline: false })

        });
        window.addEventListener('offline', function () {
            console.log('offline')
            app_set({ offline: true })
        });

        window.onresize = () => {
            app_set({ screenType: window.innerWidth < 780 ? 'mb' : 'pc' })   //暂时只区分两类
        };

        let user_name = '', roleid = '', groupid = '', menuRun = [];
        let HomePage = componentList.AsyncHome;

        //检查session中有没有存用户信息
        if (sessionStorage.getItem('token')) {
            user_name = sessionStorage.getItem('user_name');
            roleid = sessionStorage.getItem('roleid');
            groupid = sessionStorage.getItem('groupid');
        }





        if (loginUserRoleAuth) {
            listRun = []; //登陆后清空所有菜单权限
            // Menu暂时只管理两层
            menuStandard.map((obj, index) => {
                let NewItem = [];
                if (obj.Item) {
                    //Item是具体的菜单

                    let ItemObj = {};
                    obj.Item.map((d, i) => {
                        if (loginUserRoleAuth.indexOf(d.key) !== -1) {
                            ItemObj = { ...d };
                            NewItem.push(ItemObj);
                            listRun.push(d)
                        }
                    })
                }
                if (loginUserRoleAuth.indexOf(obj.key) !== -1) {   //如果菜单有，则添加，否则不添加
                    menuRun.push({ ...obj, Item: NewItem })
                }
            })



        } else {
            // 非首页手动刷新时，会检测到缺失路由，所以需要加载全部路由。后期再优化将路由保存到seesion中。暂时先赋予全部路由，登陆后清空。
            //如果未登陆，seesion会为空，强制转到登陆页。在前面有控制。

            // 这里先注释掉
            // listRun = []; //强制清空

            // urlList.map(value => {
            //     listRun.push(value);
            // })
        }

        if (user_name === '') {
            //this.props.history.push('/login');
            return (<Redirect to="/login" />)
        }

        // 初始化时期，会检测路由
        if (!inited && listRun.filter(v => v ? true : false).length > 0) {
            // 读取历史信息
            // 初始化加载
            const index = getRouteIndex(window.location.pathname, openedRoutes);
            // 如果不存在该路由，创建一个
            if (openedRoutes.length === 0 || index === -1) {
                const routeInfo = getCurrentRouteInfo();
                // 设置添加一个路由页
                if (routeInfo) {
                    requestAnimationFrame(() => {
                        app_set({
                            openedRoutes: [...openedRoutes, routeInfo]
                        });
                    });
                } else {
                    // 根页面不需要有路由, 非根页面且找不到路由，跳转到Error
                    if (window.location.pathname !== "/") {
                        requestAnimationFrame(() => {
                            this.props.history.push("/error");
                        });
                    }
                }
            } else {
                requestAnimationFrame(() => {
                    app_set({ activeTab: index });
                });
                // 存在该路由页，设置为当前tab页
            }

            // 标记完成初始化
            inited = true;
        }

        // 设置对应url
        if (openedRoutes?.[activeTab]?.url) {
            window.history.pushState({}, null, openedRoutes[activeTab].url);
        }


        return (
            <div >

                <ConfigProvider locale={zhCN}>

                    <Layout style={{ minHeight: '100vh' }}>
                        <Row style={{ background: '#004071', padding: '15px 0 15px 5px', fontSize: '18px', color: '#FFFFFF' }}>
                            <Col span={3} ><img src={djlogo} width='100px' />    </Col>
                            <div className={classes.headerRight}>
                                <Dropdown overlay={this.menutop} placement="bottomCenter">
                                    <div className={classes.user}>
                                        <Icon type="user" className={classes.userAvatar} />
                                        <span className={classes.username}>{sessionStorage.getItem("user_name")}</span>
                                    </div>
                                </Dropdown>
                            </div>
                        </Row>

                        <Layout >
                            <div className={classes.menu} style={{ backgroundColor: "white" }}>

                                <Sider style={{ background: '#fff' }}
                                    trigger={null}
                                    collapsible
                                    collapsed={screenType == 'pc' ? this.state.menuCollapsed : true}
                                >


                                    <div className="logo" />
                                    {/** 展开-收起按钮， 不可被选中 */}
                                    <Menu mode={screenType == 'pc' ? "inline" : "vertical"} selectable={false}>
                                        <Menu.Item title="展开菜单" onClick={() => this.setState({ menuCollapsed: !this.state.menuCollapsed })}>
                                            <Icon type={this.state.menuCollapsed ? 'menu-unfold' : 'menu-fold'} />
                                            <span>
                                                {
                                                    !this.state.menuCollapsed ? "收起菜单" : null
                                                }
                                            </span>
                                        </Menu.Item>
                                    </Menu>
                                    {/** 主菜单 */}
                                    <Menu
                                        theme="white"
                                        mode={screenType == 'pc' ? "inline" : "vertical"}
                                        defaultOpenKeys={["measurements"]}
                                        openKeys={this.state.openKeys}
                                        onOpenChange={(e) => {
                                            if (e.length > 0) {
                                                // 超过一个，只取最后点击的那一个展开
                                                this.setState({ openKeys: [e[e.length - 1]] })
                                            } else {
                                                // 为空，直接设置
                                                this.setState({ openKeys: e })
                                            }
                                        }}
                                    >

                                        {menuRun ? menuRun.map(obj => {
                                            if (obj.Item) {
                                                //添加到SubMenu
                                                return (
                                                    <SubMenu key={obj.key} title={<span><Icon type={obj.Icon} /><span>{obj.title}</span></span>} >
                                                        {obj.Item ? obj.Item.map(d => {
                                                            //添加Item
                                                            return (
                                                                <Menu.Item
                                                                    key={d.key}
                                                                    onClick={() => {
                                                                        let newOpenedRoutes = [...openedRoutes];

                                                                        let index = getRouteIndex(d.url, openedRoutes);

                                                                        if (index !== -1) {
                                                                            // 存在页面，跳转
                                                                            app_set({ activeTab: index });
                                                                            return;
                                                                        } else {
                                                                            // 添加一个路由页，（会自动渲染到tabs中）
                                                                            newOpenedRoutes.push(d);
                                                                            // 设置状态添加路由页面，且跳转到该页
                                                                            app_set({ openedRoutes: newOpenedRoutes, activeTab: newOpenedRoutes.length - 1 });
                                                                        }
                                                                    }}
                                                                >
                                                                    <Link to={d.url}>
                                                                        <span>
                                                                            <Icon type={d.Icon ? d.Icon : 'setting'} />
                                                                            {d.title}
                                                                        </span>
                                                                    </Link>
                                                                </Menu.Item>
                                                            )
                                                        }
                                                        ) : false}
                                                    </SubMenu>)
                                            } else {
                                                return (<Menu.Item key={obj.key} > <Icon type={obj.Icon ? obj.Icon : 'setting'} /><span><Link to={obj.url}>{obj.title}</Link></span></Menu.Item>
                                                )
                                            }
                                        }
                                        ) : false}
                                    </Menu>

                                </Sider>
                            </div>


                            <Layout>


                                <Content style={{
                                    margin: '15px 15px 15px 15px', padding: 10, background: '#fff', minHeight: 280, minWidth: '20vh',
                                }}>
                                    {
                                        window.location.pathname === "/" ? (
                                            <HomePage></HomePage>
                                        ) : (
                                            // 下面的key需要string化, key对类型敏感
                                            <Tabs
                                                activeKey={String(activeTab)}
                                                type="editable-card"
                                                // 切换页签回调
                                                onChange={(e) => {
                                                    app_set({ activeTab: e });
                                                }}
                                                // 删除页签回调
                                                onEdit={(tabIndex) => {
                                                    let index = activeTab;
                                                    const newOpenedRoutes = [...openedRoutes];
                                                    newOpenedRoutes.splice(tabIndex, 1);
                                                    // 如果索引越界，就设置为最后一个
                                                    if (activeTab > (newOpenedRoutes.length - 1)) {
                                                        index = newOpenedRoutes.length - 1;
                                                    }
                                                    app_set({ openedRoutes: newOpenedRoutes, activeTab: index });
                                                    // 如果当前打开的标签页为0，顶部url变成根
                                                    newOpenedRoutes.length === 0 && (window.history.pushState({}, null, "/"));
                                                }}
                                                // 隐藏右侧加号
                                                hideAdd={true}
                                            >
                                                {
                                                    openedRoutes.map((item, i) => {
                                                        const Com = getComponent(item.url);
                                                        return (
                                                            Com && <TabPane tab={item.title} key={String(i)} closable={true}>
                                                                <Com></Com>
                                                            </TabPane>
                                                        );
                                                    })
                                                }
                                            </Tabs>
                                        )
                                    }
                                </Content>

                                {/*} <Footer style={{ textAlign: 'center' ,marginTop:'-30px',marginBottom:'-20px'}}>
                        本软件由江苏角马智慧供应链有限公司提供技术支持
                  </Footer>*/}
                            </Layout>
                        </Layout>
                    </Layout>
                    {offline && <OfflineModal />}
                </ConfigProvider>

            </div>


        )


    }

}


const mapStateToProps = (state) => {
    return {
        app: state.appReducer
    }
}

const mapDispatchToProps = (dispatch, ownProps) => {
    return {
        app_set: (value) => dispatch(app_SET(value)),
        getroleauth: (value) => dispatch(GETROLEAUTH(value))
    }
}

const App = connect(mapStateToProps, mapDispatchToProps)(AppRender);
/*
function App(){
    return(<ConfigProvider locale={zhCN}><AppGo /></ConfigProvider>
    )
}
*/
export default App;
